/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { getPlanDuration, getPlanPrice } from "../../layout-utils";
import { Attribute } from "../../attribute";
import "./price-details.m.css";

export const PriceDetails = ({ plan, priceCurrency, priceCents, localizedTime, showOfferPrice, mode }) => {
  return (
    <div className="price" styleName={`price-wrapper ${mode}`} data-test-id="amount">
      {getPlanPrice(priceCurrency, priceCents)}
      <span className="duration" styleName="duration-wrapper" data-test-id="duration">
        {getPlanDuration(localizedTime, plan)}
      </span>
      {showOfferPrice && (
        <div styleName="attribute-wrapper">
          <Attribute data={plan} attributeName="Actual Price" />
          <Attribute data={plan} attributeName="Discount" />
        </div>
      )}
    </div>
  );
};
